import './SecondaryTab.scss';

export interface TabItem<T> {
  label: string;
  value: T;
}

interface SecondaryTabProps<T> {
  className?: string;
  activeTab?: T;
  tabs: TabItem<T>[];
  onTabChange?: (tab: T) => void;
}

const SecondaryTab = <T extends string | number>({
  className = '',
  activeTab,
  tabs,
  onTabChange,
}: SecondaryTabProps<T>) => {
  return (
    <div className={`secondary-tab ${className}`}>
      {tabs.map(tab => (
        <div
          key={tab?.value?.toString()}
          className={`secondary-tab-item ${
            activeTab === tab.value ? 'active' : ''
          }`}
          onClick={() => onTabChange?.(tab.value)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default SecondaryTab;
